import { __awaiter, __generator } from "tslib";
import { APP_CONFIG_URL, IS_ANDROID, IS_APP, IS_BAIDU, IS_IOS, IS_IOS9, IS_QQ, IS_QQ_BROWSER, IS_QQ_ZONE, IS_RN, IS_WECHAT, IS_WEIBO, } from '../constants';
import { json } from '../lib/fetch';
import { checkOpen, evokeByIFrame, evokeByLocation } from '../utils/appEvoke';
import logger from '../lib/logger';
var readyPromise = null;
var appConfig = null;
var wechatBgImg;
var wechatBgBlock;
var IS_SHOW_TIP = IS_WECHAT || IS_WEIBO || IS_BAIDU || IS_QQ || IS_QQ_BROWSER || IS_QQ_ZONE;
try {
    if (!IS_RN && !IS_APP) {
        wechatBgImg = document.createElement('img');
        wechatBgBlock = document.createElement('div');
        wechatBgBlock.appendChild(wechatBgImg);
    }
}
catch (error) { }
function showWechatTip() {
    if (IS_SHOW_TIP && (appConfig === null || appConfig === void 0 ? void 0 : appConfig.wechatImgUrl)) {
        var wechatBgUrl = appConfig.wechatBgUrl, wechatImgUrl = appConfig.wechatImgUrl;
        wechatBgImg.setAttribute('src', wechatImgUrl);
        wechatBgImg.setAttribute('style', 'width: 100%;');
        wechatBgBlock.setAttribute('style', "\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-image: url(".concat(wechatBgUrl, ");\n      background-position: center;\n      background-repeat: repeat;\n      background-size: 100%;\n      z-index: -1;\n      visibility: hidden;\n    "));
        document.body.appendChild(wechatBgBlock);
    }
}
export var readyApp = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (IS_RN || IS_APP)
            return [2 /*return*/];
        if (appConfig)
            return [2 /*return*/];
        if (readyPromise)
            return [2 /*return*/, readyPromise];
        try {
            readyPromise = json(APP_CONFIG_URL).then(function (resData) {
                readyPromise = null;
                if (resData.code === 0 && resData.data) {
                    appConfig = resData.data;
                    showWechatTip();
                }
            });
        }
        catch (error) { }
        return [2 /*return*/, readyPromise];
    });
}); };
export var downloadApp = function (type) { return __awaiter(void 0, void 0, void 0, function () {
    var lowType, _a, ios, iosUrl, android;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (IS_RN || IS_APP) {
                    logger.warn('森空岛APP内部不支持 web 下载');
                    return [2 /*return*/];
                }
                if (!readyPromise) return [3 /*break*/, 2];
                return [4 /*yield*/, readyPromise];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                if (!!appConfig) return [3 /*break*/, 4];
                return [4 /*yield*/, readyApp()];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4:
                if (!appConfig) {
                    alert('网络开小差，请稍后再试');
                    return [2 /*return*/];
                }
                lowType = type === null || type === void 0 ? void 0 : type.toLocaleLowerCase();
                if (!lowType) {
                    if (IS_IOS)
                        lowType = 'ios';
                    else if (IS_ANDROID)
                        lowType = 'android';
                    else
                        lowType = 'android';
                }
                if (IS_SHOW_TIP) {
                    wechatBgBlock.style.zIndex = '1000000';
                    wechatBgBlock.style.visibility = 'visible';
                }
                else if (lowType === 'ios') {
                    _a = appConfig.downloadUrl || {}, ios = _a.ios, iosUrl = _a.iosUrl;
                    if (ios) {
                        if (IS_IOS)
                            window.location.href = ios;
                        else
                            window.open(iosUrl);
                    }
                    else {
                        alert('系统开小差，请稍后再试');
                    }
                }
                else if (lowType === 'android') {
                    android = (appConfig.downloadUrl || {}).android;
                    if (android) {
                        window.location.href = android;
                    }
                    else {
                        alert('系统开小差，请稍后再试');
                    }
                }
                return [2 /*return*/];
        }
    });
}); };
export var openApp = function (schema, callback) { return __awaiter(void 0, void 0, void 0, function () {
    var isSchema;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isSchema = schema.indexOf('skland://') === 0;
                if (!isSchema)
                    return [2 /*return*/];
                if (!IS_SHOW_TIP) return [3 /*break*/, 1];
                wechatBgBlock.style.zIndex = '1000000';
                wechatBgBlock.style.visibility = 'visible';
                return [3 /*break*/, 6];
            case 1:
                if (!readyPromise) return [3 /*break*/, 3];
                return [4 /*yield*/, readyPromise];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                if (!!appConfig) return [3 /*break*/, 5];
                return [4 /*yield*/, readyApp()];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                if (IS_IOS) {
                    // universal link 方案未实现
                    if (IS_IOS9) {
                        evokeByIFrame(schema);
                        checkOpen(function () {
                            callback === null || callback === void 0 ? void 0 : callback();
                        }, 2000);
                    }
                    else {
                        evokeByLocation(schema);
                        checkOpen(function () {
                            callback === null || callback === void 0 ? void 0 : callback();
                        }, 2000);
                    }
                }
                else {
                    evokeByIFrame(schema);
                    checkOpen(function () {
                        callback === null || callback === void 0 ? void 0 : callback();
                    }, 2000);
                }
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); };
